import { EditableText } from '@blueprintjs/core'
import React from 'react'
import { SaveEditedContentInfirebase } from '../Functions/EditText/EditText'

function EditCustomCreate({
    content,
    setEditedContent,
    editedContent,
    setEditing,
    setContent,
    fbProfile,
    auth,
    docId,
}) {

    const handleChange = (e) =>{
        setEditedContent(e)
    }

    const handleSave = (e) => {
        setEditing(false)
        setContent(editedContent)
        SaveEditedContentInfirebase(fbProfile, auth, docId, editedContent)
    }

    return (
        <div className="p-6 border-2 border-gray-200 rounded-md shadow">
            <EditableText 
             multiline={true}
             defaultValue={content}
             onChange={handleChange}
            />
            <div className="mt-6 flex ">
                <button
                className='bg-blue-800 border-2 border-blue-600 hover:bg-blue-200 rounded p-1 font-semibold text-white hover:text-black'
                onClick={handleSave}
                >
                    Approve Changes
                </button>
                <button
                className='bg-red-800 border-2 ml-4 border-red-600 hover:bg-red-200 rounded p-1 font-semibold text-white hover:text-black'
                onClick={() => setEditing(false)}
                >
                    Cancel
                </button>
            </div>
        </div>
    )
}

export default EditCustomCreate
